import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {FileInfo} from '@features/treaty/models/treaty.models';
import {IDialogView} from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';
import {DialogModel} from '@shared/models/dialog.model';
import {Router} from '@angular/router';
import {DialogService} from '@shared/services/dialog-service';

@Component({
    standalone: false,
    selector: 'app-platform-tool-treaty-other-version-popup',
  templateUrl: './platform-tool-treaty-other-version-popup.component.html',
  styleUrls: ['./platform-tool-treaty-other-version-popup.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PlatformToolTreatyOtherVersionPopupComponent implements OnInit, IDialogView {

  data: DialogModel;
  otherVersions: FileInfo[];
  constructor(
    private dialogService: DialogService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.otherVersions = this.data?.input?.otherVersions;
  }

  showPdf(file: FileInfo) {
    const countryCodeOne = this.data?.input?.countryOne;
    const countryCodeTwo = this.data?.input?.countryTwo;
    this.dialogService.closeDialog(this.data);
    this.router.navigateByUrl(`treaties/${countryCodeOne.toLowerCase()}/${countryCodeTwo.toLowerCase()}/${file.id}`);
  }

  onCancelClicked(): any {
    return true;
  }

  onClosedClicked(): any {
    return true;
  }

  onOkClicked(): any {
    return true;
  }

  onOptionalButtonClicked(): boolean {
    return false;
  }

  onOtherButtonClicked(): boolean {
    return false;
  }

}
